/*Ad-flags */
var mgid_flags = {};

function init_unit(selector, content, method, script, flag)
{
    if( typeof mgid_flags[flag] == 'undefined' ){
        // console.log("load_mgid_units init_unit", selector, content, method, script, flag);
        $(selector)[method](content);

        Utils.load_script(script);
        mgid_flags[flag] = 'loaded';
    }
}

function lazy_load_unit(selector, content, method, script, flag)
{
    var lazy_init_callback = function(){
        if( window.$(selector).length > 0 && window.$(selector).inViewport(50) ){
            init_unit(selector, content, method, script, flag);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function lazy_load_taboola_unit(selector, code) {

    var lazy_init_callback = function(){
        if( window.$(selector).length > 0 && window.$(selector).inViewport(-300) ){
            code();
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function load_taboola_units() {

    var selector = null,
        content = null,
        method = null,
        script = null,
        flag = null;

    if (siteName == 'politics') {

        if ($('body').hasClass('home')) {

            lazy_load_taboola_unit(
                '#taboola-feed-below-homepage',

                function () {
                    window._taboola = window._taboola || [];
                    _taboola.push({
                        mode: 'alternating-thumbnails-a',
                        container: 'taboola-feed-below-homepage',
                        placement: 'Feed Below Homepage',
                        target_type: 'mix'
                    });
                }
            );

            if (document.body.clientWidth >= 768) { // Desktop & Tablet

                lazy_load_taboola_unit(
                    '#taboola-mid-homepage-thumbnails',

                    function () {
                        window._taboola = window._taboola || [];
                        _taboola.push({
                            mode: 'thumbnails-mid-home',
                            container: 'taboola-mid-homepage-thumbnails',
                            placement: 'Mid-Homepage Thumbnails',
                            target_type: 'mix'
                        });
                    }
                );

                lazy_load_taboola_unit(
                    '#taboola-left-rail-homepage',

                    function () {
                        window._taboola = window._taboola || [];
                        _taboola.push({
                            mode: 'thumbnails-lr-stream-home',
                            container: 'taboola-left-rail-homepage',
                            placement: 'Left Rail-Homepage',
                            target_type: 'mix'
                        });
                    }
                );

                lazy_load_taboola_unit(
                    '#taboola-right-rail-homepage',

                    function () {
                        window._taboola = window._taboola || [];
                        _taboola.push({
                            mode: 'thumbnails-rr-home',
                            container: 'taboola-right-rail-homepage',
                            placement: 'Right Rail-Homepage',
                            target_type: 'mix'
                        });
                    }
                );

            } else { // Mobile only

                lazy_load_taboola_unit(
                    '#taboola-mid-homepage-reco-reel',

                    function () {
                        window._taboola = window._taboola || [];
                        _taboola.push({
                            mode: 'alternating-rec-reel-3n4-a-homepage',
                            container: 'taboola-mid-homepage-reco-reel',
                            placement: 'Mid Homepage Reco Reel',
                            target_type: 'mix'
                        });
                    }
                );
            }
        }

        //article
        if ($('body').hasClass('article') && !$('body').hasClass('rcor')) { //removing ads from Realclearopinion reserach pieces

            //Mobile
            //After the comments 
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined') {

                lazy_load_taboola_unit(
                    '#taboola-mid-article-mobile',

                    function () {
                        window._taboola = window._taboola || [];
                        _taboola.push({
                            mode: 'alternating-rec-reel-3n4-a-article-mobile',
                            container: 'taboola-mid-article-mobile',
                            placement: 'Mid Article Mobile',
                            target_type: 'mix'
                        });
                    }
                );

            } else {

                //Desktop or window larger then 768px will load on the right column
                lazy_load_taboola_unit(
                    '#taboola-right-rail-article-page',

                    function () {
                        window._taboola = window._taboola || [];
                        _taboola.push({
                            mode: 'thumbnails-rr-article',
                            container: 'taboola-right-rail-article-page',
                            placement: 'Right Rail-Article Page',
                            target_type: 'mix'
                        });
                    }
                );

            }
            
            //load add after fifth paragraph. 
            lazy_load_taboola_unit(
                '#taboola-mid-article-desktop-tablet',

                function () {
                    window._taboola = window._taboola || [];
                    _taboola.push({
                        mode: 'thumbnails-mid-desktop',
                        container: 'taboola-mid-article-desktop-tablet',
                        placement: 'Mid-Article Desktop-Tablet',
                        target_type: 'mix'
                    });
                }
            );

            
            if (typeof mgid_flags.bf_comments == 'undefined') {

                if ($('.alpha .comments-wrapper').length > 0) {

                    selector = '.alpha .comments-wrapper';

                } else {
                    selector = '.alpha-long .comments-wrapper';
                }


                lazy_load_taboola_unit(
                    selector,

                    function () {
                        window._taboola = window._taboola || [];
                        _taboola.push({
                            mode: 'alternating-thumbnails-a',
                            container: 'taboola-feed-below-article',
                            placement: 'Feed Below Article',
                            target_type: 'mix'
                        });
                    }
                );

            }

        }



    }


    console.log('end of load taboola');

}    

function load_mgid_units() {

    // console.log("load_mgid_units siteName", siteName);

    var selector = null,
        content = null,
        method = null,
        script = null,
        flag = null;

    //Only for politics
    // if (siteName == 'politics') {
    //
    //     var $url = "https://jsc.mgid.com/r/e/realclearpolitics.com.";
    //
    //     //homepage
    //     if ($('body').hasClass('home')) {
    //
    //         // console.log("load_mgid_units politics home");
    //
    //         //On mobile it will be placed on top of Mixi on alpha
    //         //Desktop will be palced on gamma
    //         //<!-- Composite Start --> <div id="M478141ScriptRootC970897"> </div> <script src="https://jsc.mgid.com/r/e/realclearpolitics.com.970897.js" async></script> <!-- Composite End -->
    //         if (document.body.clientWidth < 768 ) {
    //
    //             //Mobile: Above the From partners mixi widet on the alpha column
    //             // if ( typeof mgid_flags.mobile_center_section == 'undefined') {
    //
    //                 //$(window).off('scroll', load_mgid_units);
    //                 // $('.alpha .RC-AD-BOX-MOBILE_2 ').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_hp_rc'] + '"></div>');
    //
    //                 // show on right column
    //                 // $('.beta-container:not(.clone) .beta').append('<div id="M478141ScriptRootC' + SITE_INFO['mgid_hp_rc'] + '"></div>');
    //
    //                 // Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
    //                 // mgid_flags.mobile_center_section = 'loaded';
    //
    //                 /*selector = '.beta-container:not(.clone) .beta';
    //                 content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_hp_rc'] + '"></div>';
    //                 method = 'append';
    //                 script = $url + SITE_INFO['mgid_hp_rc'] + ".js";
    //                 flag = 'mobile_center_section';
    //
    //                 lazy_load_unit(selector, content, method, script, flag);*/
    //             // }
    //
    //         } else {
    //
    //             /*console.log("load_mgid_units ",  typeof mgid_flags.hp_rc_slot,  mgid_flags.hp_rc_slot);
    //
    //             //Desktop: Right Column Only
    //             //this is only going to trigger on desktop
    //             // selector = '.beta .widget_slot:eq(3)';
    //             selector = '.beta #mgid-right-col-desktop';
    //             content = '<div style="min-height: 1080px;" id="M478141ScriptRootC' + SITE_INFO['mgid_hp_rc'] + '"></div>';
    //             method = 'after';
    //             script = $url + SITE_INFO['mgid_hp_rc'] + ".js";
    //             flag = 'hp_rc_slot';
    //
    //             lazy_load_unit(selector, content, method, script, flag);*/
    //         }
    //
    //         //Left column widget
    //         // if (  typeof mgid_flags.hp_lc == 'undefined' ) {
    //             //$(window).off('scroll', load_mgid_units);
    //             // $('.gamma #most-read-box').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_hp_id'] + '"></div>');
    //
    //             // Utils.load_script($url + SITE_INFO['mgid_hp_id'] + ".js");
    //             // mgid_flags.hp_lc = 'loaded';
    //         // }
    //
    //         /*selector = '.gamma #most-read-box';
    //         content = '<div style="min-height: 718px;" id="M478141ScriptRootC' + SITE_INFO['mgid_hp_id'] + '"></div>';
    //         method = 'after';
    //         script = $url + SITE_INFO['mgid_hp_id'] + ".js";
    //         flag = 'hp_lc';
    //
    //         lazy_load_unit(selector, content, method, script, flag);
    //
    //         // Center column widget
    //         // if(  typeof mgid_flags.hp_after_covid == 'undefined'){
    //
    //             selector = '.alpha #rclife_widget_center_column';
    //             if($(selector).length > 0){ //covid table non-existent - we look for other option
    //
    //                 // $('.alpha #rclife_widget_center_column').before('<div id="M478141ScriptRootC' + SITE_INFO['mgid_hp_after_covid'] + '"></div>');
    //                 method = 'before';
    //
    //             }else{
    //                 // $('.alpha .list-view .spot-box').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_hp_after_covid'] + '"></div>');
    //                 selector = '.alpha .list-view .spot-box';
    //                 method = 'after';
    //             }
    //
    //             // Utils.load_script($url + SITE_INFO['mgid_hp_after_covid'] + ".js");
    //             // mgid_flags.hp_after_covid = 'loaded';
    //         // }
    //
    //         content = '<div style="min-height: 250px" id="M478141ScriptRootC' + SITE_INFO['mgid_hp_after_covid'] + '"></div>';
    //         script = $url + SITE_INFO['mgid_hp_after_covid'] + ".js";
    //         flag = 'hp_after_covid';
    //
    //         lazy_load_unit(selector, content, method, script, flag);*/
    //
    //         /*
    //             Lazyloaded sisabled
    //         if(Object.keys(mgid_flags).length == 3){
    //             $(window).off('scroll', load_mgid_units);
    //         }*/
    //
    //
    //     }
    //
    //     //polls  page
    //     if ($('body').hasClass('polls')) {
    //
    //         //Desktop
    //         //Location: Latest polls Page
    //         //After last talbe before the shorte news secction only
    //         if ( typeof mgid_flags.polls_mc == 'undefined') {
    //
    //             // $('.alpha #short_news').before('<div id="M478141ScriptRootC' + SITE_INFO['mgid_polls_id'] + '"></div>');
    //             // Utils.load_script($url + SITE_INFO['mgid_polls_id'] + ".js");
    //             // mgid_flags.polls_mc = 'loaded';
    //
    //             selector = '.alpha #short_news';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_polls_id'] + '"></div>';
    //             method  = 'before';
    //             script  = $url + SITE_INFO['mgid_polls_id'] + ".js";
    //             flag    = 'polls_mc';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //         }
    //
    //         //right column widgtet
    //         if(  typeof mgid_flags.polls_rc == 'undefined' ){
    //
    //             // $('.beta .widget_slot:eq(3)').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_polls_rc'] + '"></div>');
    //             // Utils.load_script($url + SITE_INFO['mgid_polls_rc'] + ".js");
    //             // mgid_flags.polls_rc = 'loaded';
    //
    //             selector = '.beta .widget_slot:eq(3)';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_polls_rc'] + '"></div>';
    //             method  = 'after';
    //             script  = $url + SITE_INFO['mgid_polls_rc'] + ".js";
    //             flag    = 'polls_rc';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //         }
    //         //after the second polling data table only if its not latest poll page
    //         if(  typeof mgid_flags.after_second_data_table == 'undefined' && $('body').attr('data-page') !== 'latest_polls'){
    //
    //             // $('.alpha .RC-AD-BOTTOM-BANNER').before('<div id="M478141ScriptRootC' + SITE_INFO['mgid_polls_id'] + '"></div>');
    //             // Utils.load_script($url + SITE_INFO['mgid_polls_id'] + ".js");
    //             // mgid_flags.after_second_data_table = 'loaded';
    //
    //             selector = '.alpha .RC-AD-BOTTOM-BANNER';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_polls_id'] + '"></div>';
    //             method  = 'before';
    //             script  = $url + SITE_INFO['mgid_polls_id'] + ".js";
    //             flag    = 'after_second_data_table';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //         }
    //
    //
    //          if(  typeof mgid_flags.polls_carousel == 'undefined'  && $('body').attr('data-page') !== 'latest_polls'){
    //
    //             // $('.alpha .distro-with-ad').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_polls_carousel'] + '"></div>');
    //             // Utils.load_script($url + SITE_INFO['mgid_polls_carousel'] + ".js");
    //             // mgid_flags.polls_carousel = 'loaded';
    //
    //             selector = '.alpha .distro-with-ad';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_polls_carousel'] + '"></div>';
    //             method  = 'after';
    //             script  = $url + SITE_INFO['mgid_polls_carousel'] + ".js";
    //             flag    = 'polls_carousel';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //         }
    //
    //        /* if(Object.keys(mgid_flags).length == 3 || (Object.keys(mgid_flags).length == 2 && $('body').attr('data-page') == 'latest_polls') ){
    //             $(window).off('scroll', load_mgid_units);
    //         }*/
    //
    //     }
    //
    //     //article
    //     if($('body').hasClass('article') && !$('body').hasClass('rcor') ){ //removing ads from Realclearopinion reserach pieces
    //
    //     	//Mobile
    //     	//After the comments 
    //         if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {
    //
    //         	// $('.alpha #comments-container').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
    //             // //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
    //             // mgid_flags.mobile_center_c_article = 'loaded';
    //
    //             selector = '.alpha #comments-container';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>';
    //             method  = 'after';
    //             script  = $url + SITE_INFO['mgid_article_rc_id'] + ".js";
    //             flag    = 'mobile_center_c_article';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //
    //         }else{
    //
    //         	//Desktop or window larger then 768px will load on the right column
    //         	if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {
    //
    //                 // $('.beta .RC-AD-BOX-TOP').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
    //                 // //load script for this unit
    //                 // Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
    //                 // mgid_flags.beta_rc_top = 'loaded';
    //
    //                 selector = '.beta .RC-AD-BOX-TOP';
    //                 content = '<div style="min-height: 500px;" id="M478141ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>';
    //                 method  = 'after';
    //                 script  = $url + SITE_INFO['mgid_article_rc_id'] + ".js";
    //                 flag    = 'beta_rc_top';
    //
    //                 lazy_load_unit(selector, content, method, script, flag);
    //
    //         	}
    //
    //         }
    //
    //
    //
    //         //Will load after the fith paragraph
    //         if(  typeof mgid_flags.article_carousel == 'undefined'  ) {
    //
    //             // $('.article-body-text p').eq(5).after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_article_carousel'] + '"></div>');
    //             // //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
    //             // mgid_flags.article_carousel = 'loaded';
    //
    //             // selector = '.article-body-text p:eq(5)';
    //             // content = '<div style="min-height: 250px" id="M478141ScriptRootC' + SITE_INFO['mgid_article_carousel'] + '"></div>';
    //             // method  = 'after';
    //             // script  = $url + SITE_INFO['mgid_article_carousel'] + ".js";
    //             // flag    = 'article_carousel';
    //
    //             // lazy_load_unit(selector, content, method, script, flag);
    //
    //         }
    //         //Will load after the 12 paragraph
    //         if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {
    //
    //             // $('.article-body-text p').eq(12).after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
    //             // //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
    //             // mgid_flags.in_c_p12 = 'loaded';
    //
    //             selector = '.article-body-text p:eq(12)';
    //             content = '<div style="min-height: 250px;" id="M478141ScriptRootC' + SITE_INFO['mgid_article_in_content_p12'] + '"></div>';
    //             method  = 'after';
    //             script  = $url + SITE_INFO['mgid_article_in_content_p12'] + ".js";
    //             flag    = 'in_c_p12';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //
    //         }
    //
    //         if( typeof mgid_flags.bf_comments == 'undefined'){
    //
    //             if($('.alpha .comments-wrapper').length > 0 ){
    //
    //                 //standard format
    //                 // $('.alpha .comments-wrapper').before('<div id="M478141ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
    //                 selector = '.alpha .comments-wrapper';
    //
    //             }else{
    //
    //                 //Long format
    //                 // $('.alpha-long .comments-wrapper').before('<div id="M478141ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
    //                 selector = '.alpha-long .comments-wrapper';
    //             }
    //
    //             //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
    //             // mgid_flags.bf_comments = 'loaded';
    //
    //             content = '<div style="min-height: 1500px;" id="M478141ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>';
    //             method  = 'before';
    //             script  = $url + SITE_INFO['mgid_article_bf_comments'] + ".js";
    //             flag    = 'bf_comments';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //
    //         }
    //
    //         //if all the ad placements have been placed in the page then at this time we will remove the event handler
    //         /*if(Object.keys(mgid_flags).length == 4){
    //             console.log('offf');
    //             $(window).off('scroll', load_mgid_units);
    //         }*/
    //
    //     }
    //
    //     if($('body').hasClass('video-perma')){
    //
    //         if( typeof mgid_flags.video_bc == 'undefined'){
    //
    //             // $('.alpha .comments-wrapper').before('<div id="M478141ScriptRootC' + SITE_INFO['mgid_video'] + '"></div>');
    //             // //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_video'] + ".js");
    //             // mgid_flags.video_bc = 'loaded';
    //
    //             selector = '.alpha .comments-wrapper';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_video'] + '"></div>';
    //             method  = 'before';
    //             script  = $url + SITE_INFO['mgid_video'] + ".js";
    //             flag    = 'video_bc';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //
    //         }
    //
    //
    //         //Mobile
    //         //move it to the alpha column
    //         if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_video == 'undefined' ) {
    //
    //             // $('.alpha #comments-container').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>');
    //             // //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_video_rc'] + ".js");
    //             // mgid_flags.mobile_center_c_video = 'loaded';
    //
    //             selector = '.alpha #comments-container';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>';
    //             method  = 'after';
    //             script  = $url + SITE_INFO['mgid_video_rc'] + ".js";
    //             flag    = 'mobile_center_c_video';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //
    //         }else{
    //             //Desktop Widget
    //             if(  typeof mgid_flags.video_rc == 'undefined' ){
    //
    //                 // $('.beta .widget_slot:eq(2)').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>');
    //
    //                 // Utils.load_script($url + SITE_INFO['mgid_video_rc'] + ".js");
    //                 // mgid_flags.video_rc = 'loaded';
    //
    //                 selector = '.beta .widget_slot:eq(2)';
    //                 content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>';
    //                 method  = 'after';
    //                 script  = $url + SITE_INFO['mgid_video_rc'] + ".js";
    //                 flag    = 'video_rc';
    //
    //                 lazy_load_unit(selector, content, method, script, flag);
    //             }
    //         }
    //
    //        /* if(Object.keys(mgid_flags).length == 2){
    //             $(window).off('scroll', load_mgid_units);
    //         }*/
    //     }
    //
    //     if($('body').hasClass('election')){
    //         //right side bar widget
    //         if( typeof mgid_flags.election_rc == 'undefined'){
    //
    //             // $('.beta .RC-AD-BOX-TOP').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>');
    //             // //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_video_rc'] + ".js"); //widget id 977465
    //             // mgid_flags.election_rc = 'loaded';
    //
    //             selector = '.beta .RC-AD-BOX-TOP';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>';
    //             method  = 'after';
    //             script  = $url + SITE_INFO['mgid_video_rc'] + ".js";
    //             flag    = 'election_rc';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //         }
    //
    //
    //         if( typeof mgid_flags.election_carousel == 'undefined'){
    //
    //             // $('.alpha .news_items').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_election_carousel'] + '"></div>');
    //             // //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_election_carousel'] + ".js"); //widget id 970915
    //             // mgid_flags.election_carousel = 'loaded';
    //
    //             selector = '.alpha .news_items';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_election_carousel'] + '"></div>';
    //             method  = 'after';
    //             script  = $url + SITE_INFO['mgid_election_carousel'] + ".js";
    //             flag    = 'election_carousel';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //         }
    //
    //
    //         if( typeof mgid_flags.election_smart_widget == 'undefined'){
    //
    //             // $('.alpha #more_news').after('<div id="M478141ScriptRootC' + SITE_INFO['mgid_video'] + '"></div>');
    //             // //load script for this unit
    //             // Utils.load_script($url + SITE_INFO['mgid_video'] + ".js"); //widget id 970915
    //             // mgid_flags.election_smart_widget = 'loaded';
    //
    //             selector = '.alpha #more_news';
    //             content = '<div id="M478141ScriptRootC' + SITE_INFO['mgid_video'] + '"></div>';
    //             method  = 'after';
    //             script  = $url + SITE_INFO['mgid_video'] + ".js";
    //             flag    = 'election_smart_widget';
    //
    //             lazy_load_unit(selector, content, method, script, flag);
    //         }
    //
    //
    //
    //
    //
    //     }
    //
    // }

    if(siteName == 'science'){
        $url = 'https://jsc.mgid.com/r/e/realclearscience.com.';
        //Homepage only
        if($('body').hasClass('home')){
            //<!-- Composite Start --> <div id="M440576ScriptRootC992065"> </div> <script src="https://jsc.mgid.com/r/e/realclearscience.com.992065.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.science_carousell == 'undefined'){

                // $('.alpha #insticator-ad-wrapper').after('<div class="line"></div><div id="M440576ScriptRootC' + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                // Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                // mgid_flags.science_carousell = 'loaded';

                selector = '.alpha #insticator-ad-wrapper';
                content = '<div class="line"></div><div id="M440576ScriptRootC' + SITE_INFO['mgid_hp_carosell'] + '"></div>';
                method  = 'after';
                script  = $url + SITE_INFO['mgid_hp_carosell'] + ".js";
                flag    = 'science_carousell';

                lazy_load_unit(selector, content, method, script, flag);

            }

            //Left column widget
            if(typeof mgid_flags.science_hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.science_hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.science_hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM-600').before('<div id="M440576ScriptRootC' + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.science_hp_rc = 'loaded';
            }

        }

        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if($('.beta .widget_slot:eq(2)').length > 0) {

                        $('.beta .widget_slot:eq(2)').after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="M440576ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="M440576ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }

        if($('body').hasClass('video-perma')){

            if( typeof mgid_flags.video_bc == 'undefined'){

                $('.alpha .bottom-banner').after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_video'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_video'] + ".js");
                mgid_flags.video_bc = 'loaded';

            }


            //Mobile
            //move it to the alpha column
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_video == 'undefined' ) {

                $('.alpha .bottom-banner').after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_video_rc'] + ".js");
                mgid_flags.mobile_center_c_video = 'loaded';

            }else{
                //Desktop Widget
                if(  typeof mgid_flags.video_rc == 'undefined' ){

                    $('.beta .widget_slot:eq(2)').after('<div id="M440576ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>');

                    Utils.load_script($url + SITE_INFO['mgid_video_rc'] + ".js");
                    mgid_flags.video_rc = 'loaded';
                }
            }

        }
    }

    if(siteName == 'world'){
        $url = 'https://jsc.mgid.com/r/e/realclearworld.com.';
        //Homepage only
        if($('body').hasClass('home')){
            //<!-- Composite Start --> <div id="M498915ScriptRootC991941"> </div> <script src="https://jsc.mgid.com/r/e/realclearworld.com.991941.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.world_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="M498915ScriptRootC' + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.world_carousell = 'loaded';

            }
            //Left column widget
            if(typeof mgid_flags.world_hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.world_hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.world_hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM-600').before('<div id="M498915ScriptRootC' + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.world_hp_rc = 'loaded';
            }

        }

        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if($('.beta .RC-AD-BOX-TOP').length > 0) {

                        $('.beta .RC-AD-BOX-TOP').after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="M498915ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="M498915ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }

        if($('body').hasClass('video-perma')){

            if( typeof mgid_flags.video_bc == 'undefined'){

                $('.alpha .bottom-banner').after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_video'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_video'] + ".js");
                mgid_flags.video_bc = 'loaded';

            }


            //Mobile
            //move it to the alpha column
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_video == 'undefined' ) {

                $('.alpha .bottom-banner').after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_video_rc'] + ".js");
                mgid_flags.mobile_center_c_video = 'loaded';

            }else{
                //Desktop Widget
                if(  typeof mgid_flags.video_rc == 'undefined' ){

                    $('.beta .widget_slot:eq(2)').after('<div id="M498915ScriptRootC' + SITE_INFO['mgid_video_rc'] + '"></div>');

                    Utils.load_script($url + SITE_INFO['mgid_video_rc'] + ".js");
                    mgid_flags.video_rc = 'loaded';
                }
            }

        }

    }

    if(siteName == 'defense'){
        $url = 'https://jsc.mgid.com/r/e/realcleardefense.com.';
        //Homepage only
        if($('body').hasClass('home')){
            //<!-- Composite Start --> <div id="M498915ScriptRootC991941"> </div> <script src="https://jsc.mgid.com/r/e/realclearworld.com.991941.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.defense_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="M498918ScriptRootC' + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.defense_carousell = 'loaded';

            }

            //Left column widget
            if(typeof mgid_flags.defense_hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="M498918ScriptRootC' + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.defense_hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.defense_hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM').before('<div id="M498918ScriptRootC' + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.defense_hp_rc = 'loaded';
            }

        }


        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="M498918ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if( $('.beta .widget_slot:eq(3)').length > 0) {

                        $('.beta .widget_slot:eq(3)').before('<div id="M498918ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="M498918ScriptRootC' + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="M498918ScriptRootC' + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="M498918ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="M498918ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="M498918ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }




    }

    if(siteName == 'policy'){
        $url = 'https://jsc.mgid.com/r/e/realclearpolicy.com.';
        //Homepage only
        if($('body').hasClass('home')){
            //<!-- Composite Start --> <div id="M498914ScriptRootC991834"> </div> <script src="https://jsc.mgid.com/r/e/realclearpolicy.com.991834.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.policy_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="M498914ScriptRootC' + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.policy_carousell = 'loaded';

            }

            //Right Column
            if(typeof mgid_flags.policy_hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM').before('<div id="M498914ScriptRootC' + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.policy_hp_rc = 'loaded';
            }

        }


        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="M498914ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if( $('.beta .widget_slot:eq(3)').length > 0) {

                        $('.beta .widget_slot:eq(3)').before('<div id="M498914ScriptRootC' + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="M498914ScriptRootC' + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="M498914ScriptRootC' + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="M498914ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="M498914ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="M498914ScriptRootC' + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }


    }

    if(siteName == 'history'){
        $url = 'https://jsc.mgid.com/r/e/realclearhistory.com.';
        var target_unit = 'M498922ScriptRootC';

        if($('body').hasClass('home')){

            //<!-- Composite Start --> <div id="M498915ScriptRootC991941"> </div> <script src="https://jsc.mgid.com/r/e/realclearworld.com.991941.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.history_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="' + target_unit + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.history_crousell = 'loaded';

            }
            //Left column widget
            if(typeof mgid_flags.history_hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="' + target_unit + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.history_hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.history_hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM-600').before('<div id="' + target_unit + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.history_hp_rc = 'loaded';
            }

        }

        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="'+ target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if( $('.beta .widget_slot:eq(3)').length > 0) {

                        $('.beta .widget_slot:eq(3)').before('<div id="' + target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="' + target_unit + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="' + target_unit + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }


    }

    if(siteName == 'religion'){
        $url = 'https://jsc.mgid.com/r/e/realclearreligion.org.';
        var target_unit = 'M498919ScriptRootC';

        if($('body').hasClass('home')){

            //<!-- Composite Start --> <div id="M498915ScriptRootC991941"> </div> <script src="https://jsc.mgid.com/r/e/realclearworld.com.991941.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.hp_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="' + target_unit + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.hp_crousell = 'loaded';

            }
            //Left column widget
            if(typeof mgid_flags.hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="' + target_unit + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM-600').before('<div id="' + target_unit + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.hp_rc = 'loaded';
            }

        }

        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="'+ target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if( $('.beta .widget_slot:eq(3)').length > 0) {

                        $('.beta .widget_slot:eq(3)').before('<div id="' + target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="' + target_unit + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="' + target_unit + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }


    }

    if(siteName == 'energy'){
        $url = 'https://jsc.mgid.com/r/e/realclearenergy.org.';
        var target_unit = 'M498917ScriptRootC';

        if($('body').hasClass('home')){

            //<!-- Composite Start --> <div id="M498915ScriptRootC991941"> </div> <script src="https://jsc.mgid.com/r/e/realclearworld.com.991941.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.hp_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="' + target_unit + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.hp_crousell = 'loaded';

            }
            //Left column widget
            if(typeof mgid_flags.hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="' + target_unit + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM-600').before('<div id="' + target_unit + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.hp_rc = 'loaded';
            }

        }

        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="'+ target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if( $('.beta .widget_slot:eq(3)').length > 0) {

                        $('.beta .widget_slot:eq(3)').before('<div id="' + target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="' + target_unit + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="' + target_unit + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }


    }

    if(siteName == 'education'){
        $url = 'https://jsc.mgid.com/r/e/realcleareducation.com.';
        var target_unit = 'M498920ScriptRootC';

        if($('body').hasClass('home')){

            //<!-- Composite Start --> <div id="M498915ScriptRootC991941"> </div> <script src="https://jsc.mgid.com/r/e/realclearworld.com.991941.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.hp_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="' + target_unit + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.hp_crousell = 'loaded';

            }
            //Left column widget
            if(typeof mgid_flags.hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="' + target_unit + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM-600').before('<div id="' + target_unit + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.hp_rc = 'loaded';
            }

        }

        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="'+ target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if( $('.beta .widget_slot:eq(2)').length > 0) {

                        $('.beta .widget_slot:eq(2)').before('<div id="' + target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="' + target_unit + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="' + target_unit + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }


    }

    if(siteName == 'books'){
        $url = 'https://jsc.mgid.com/r/e/realclearbooks.com.';
        var target_unit = 'M498924ScriptRootC';

        if($('body').hasClass('home')){

            //<!-- Composite Start --> <div id="M498915ScriptRootC991941"> </div> <script src="https://jsc.mgid.com/r/e/realclearworld.com.991941.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.hp_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="' + target_unit + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.hp_crousell = 'loaded';

            }
            //Left column widget
            if(typeof mgid_flags.hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="' + target_unit + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM-600').before('<div id="' + target_unit + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.hp_rc = 'loaded';
            }

        }

        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="'+ target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if( $('.beta .widget_slot:eq(2)').length > 0) {

                        $('.beta .widget_slot:eq(2)').before('<div id="' + target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="' + target_unit + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="' + target_unit + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }


    }

    if(siteName == 'health'){
        $url = 'https://jsc.mgid.com/r/e/realclearhealth.com.';
        var target_unit = 'M498916ScriptRootC';

        if($('body').hasClass('home')){

            //<!-- Composite Start --> <div id="M498915ScriptRootC991941"> </div> <script src="https://jsc.mgid.com/r/e/realclearworld.com.991941.js" async></script> <!-- Composite End -->
            if(typeof mgid_flags.hp_carousell == 'undefined'){

                $('.alpha .list-view #popular').before('<div class="line"></div><div id="' + target_unit + SITE_INFO['mgid_hp_carosell'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_carosell'] + ".js");
                mgid_flags.hp_crousell = 'loaded';

            }
            //Left column widget
            if(typeof mgid_flags.hp_lc == 'undefined'){

                $('.gamma #most-read-box').after('<div id="' + target_unit + SITE_INFO['mgid_hp_lc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_lc'] + ".js");
                mgid_flags.hp_lc = 'loaded';
            }
            //Right Column
            if(typeof mgid_flags.hp_rc == 'undefined'){

                $('.beta .RC-AD-BOX-BOTTOM-600').before('<div id="' + target_unit + SITE_INFO['mgid_hp_rc'] + '"></div>');
                Utils.load_script($url + SITE_INFO['mgid_hp_rc'] + ".js");
                mgid_flags.hp_rc = 'loaded';
            }

        }

        if($('body').hasClass('article')){

            //Mobile
            //After the comments
            if (document.body.clientWidth < 768 && typeof mgid_flags.mobile_center_c_article == 'undefined' ) {

                $('.alpha #comments-container').after('<div id="'+ target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                mgid_flags.mobile_center_c_article = 'loaded';

            }else{

                //Desktop or window larger then 768px will load on the right column
                if(  typeof mgid_flags.beta_rc_top == 'undefined' ) {

                    if( $('.beta .widget_slot:eq(2)').length > 0) {

                        $('.beta .widget_slot:eq(2)').before('<div id="' + target_unit + SITE_INFO['mgid_article_rc_id'] + '"></div>');
                        //load script for this unit
                        Utils.load_script($url + SITE_INFO['mgid_article_rc_id'] + ".js");
                        mgid_flags.beta_rc_top = 'loaded';
                    }
                }

            }

            //Will load after the fith paragraph
            if(  typeof mgid_flags.article_carousel == 'undefined'  ) {

                $('.article-body-text p').eq(5).after('<div id="' + target_unit + SITE_INFO['mgid_article_carousel'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_carousel'] + ".js");
                mgid_flags.article_carousel = 'loaded';

            }
            //Will load after the 12 paragraph
            if(  typeof mgid_flags.in_c_p12 == 'undefined'  ) {

                $('.article-body-text p').eq(12).after('<div id="' + target_unit + SITE_INFO['mgid_article_in_content_p12'] + '"></div>');
                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_in_content_p12'] + ".js");
                mgid_flags.in_c_p12 = 'loaded';

            }

            if( typeof mgid_flags.bf_comments == 'undefined'){

                if($('.alpha .comments-wrapper').length > 0 ){
                    //standard format
                    $('.alpha .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                }else{
                    //Long format
                    if($('.alpha-long .no-comments').length > 0){
                        $('.alpha-long .no-comments').after('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }else{
                        $('.alpha-long .comments-wrapper').before('<div id="' + target_unit + SITE_INFO['mgid_article_bf_comments'] + '"></div>');
                    }

                }

                //load script for this unit
                Utils.load_script($url + SITE_INFO['mgid_article_bf_comments'] + ".js");
                mgid_flags.bf_comments = 'loaded';

            }


        }


    }



}

function init_mgid_units()
{
    load_taboola_units();

    if (Utils.get_query_param('mgid') == 1 || $('body').hasClass('article')) {

        var event_data = {
            'ge_action': 'articles enabled',
            'ge_category': 'MGID',
            'ge_label': 'article',
            'ge_noninteraction': true
        };
        send_ga_event(event_data);

        //$(window).on('scroll resize', load_mgid_units).scroll().resize();
        // will call the function to load
        load_mgid_units();

    } else if (Utils.get_query_param('mgid') == null) { //Math.random() < .25 &&

        //$(window).on('scroll resize', load_mgid_units).scroll().resize();
        console.log('MGID Loaded');

        var body_class = $('body').attr('class');
        var event_data = {
            'ge_action': 'enabled',
            'ge_category': 'MGID',
            'ge_label': body_class,
            'ge_noninteraction': true
        };

        send_ga_event(event_data);
        //Loads the units on the
        load_mgid_units();
    } else {

        var body_class = $('body').attr('class');
        var event_data = {
            'ge_action': 'disabled',
            'ge_category': 'MGID',
            'ge_label': body_class,
            'ge_noninteraction': true
        };

        send_ga_event(event_data);
    }
}

export default init_mgid_units;